// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"27":"d2633140","729":"4beff553","770":"93209e9f","918":"0c3a77e3"}[chunkId] + ".chunk.js";
};